export default "/images/1cdbc7283c2a14953bd0fcc05d354fc9.avif";